// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"L3-z","dimensionLabel":"M3-z","styleChooserControlWrapper":"N3-z","styleChooserControl":"O3-z","disabled":"P3-z","giftCard":"Q3-z","styleChooserText":"R3-z"};